import { render, staticRenderFns } from "./OposDatepicker.vue?vue&type=template&id=9f8bb72e&"
import script from "./OposDatepicker.vue?vue&type=script&lang=js&"
export * from "./OposDatepicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports